import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Options } from 'tabulator-tables';
import {
  TransformationService,
  TabulatorService,
  ActiveTestQueuedStateService,
  DialogService
} from '@nrwl/common-lib';
import { MonitorsService } from '@nrwl/monitor-management';
import { ViaviTableComponent } from '@nrwl/viavi-tabulator';

import { MultipickerService } from '../../service/multipicker.service';

@Component({
  selector: 'nrwl-site-table',
  templateUrl: './site-table.component.html',
  styleUrls: ['./site-table.component.scss']
})
export class SiteTableComponent implements OnInit {
  @ViewChild(ViaviTableComponent) siteTable: ViaviTableComponent;
  // eslint-disable-next-line
  @Input() sites: any;
  // eslint-disable-next-line
  @Input() selectedSites: any;
  // eslint-disable-next-line
  @Input() deviceComp: any;
  //eslint-disable-next-line
  @Input() hidingData: any;
  //eslint-disable-next-line
  @Input() hidingSiteData: any;
  @Input() singleSelection: boolean;
  @Input() testType: string;
  @Input() hideResourceUnavailableAgent: boolean;
  table: Options;
  deviceWithMonitors = [];
  constructor(
    private transformService: TransformationService,
    private tabulatorService: TabulatorService,
    private multipickerService: MultipickerService,
    private activeTestQueuedStateService: ActiveTestQueuedStateService,
    private monitorsService: MonitorsService,
    private dialogService: DialogService
  ) {
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.persistenceID = 'multi-site-selection';
    this.table.groupHeader = this.tabulatorService.groupHeader;
  }
  ngOnInit(): void {
    if (this.sites && this.sites.length > 0) {
      if (this.hidingSiteData) {
        this.sites = this.sites.filter(item => item.id !== this.hidingSiteData.id);
      }
      if (this.hidingData) {
        this.sites = this.sites.filter(item => item?.id !== this.hidingData.site.id);
      }
      this.assignData();
    }
  }
  assignData(): void {
    this.sites.forEach(site => {
      site.isChecked = false;
      site.warningMessage = this.multipickerService.getWarningMessage(
        site.id,
        null,
        site.status,
        this.testType
      );

      site.testAssigned = this.getTestAssignedValueForSites(site);
      if (this.selectedSites && this.selectedSites.length > 0) {
        if (this.selectedSites.find(filteredId => site.id === filteredId.id)) {
          site.isChecked = true;
        }
      }
    });
    if (this.hideResourceUnavailableAgent) {
      this.sites = this.sites.filter(site => !site.warningMessage);
    }

    const statusOrder = ['online', '', 'offline'];
    this.sites = this.sites.sort(function (a, b) {
      return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
    });
    const transformedData = this.transformService.transformData('site-dropdown', this.sites);
    this.table.height = 500;
    delete this.table.rowHeight;
    if (this.singleSelection) {
      delete this.table.selectable;
      delete this.table.selectableRangeMode;
    }
    this.table.columns = transformedData.column;
    this.table.data = transformedData.data;
    this.table.persistence.sort = true;
    this.table.persistence.page = true;
    if (this.singleSelection) {
      this.table.hideSelectAll = true;
    }
    this.table = Object.assign({}, this.table);
  }

  // eslint-disable-next-line
  getTestAssignedValueForSites(site: any): any {
    this.deviceWithMonitors = this.activeTestQueuedStateService.getDevicesWithTests();
    const allTestAssignedValues = site.devices.map(item => {
      return this.multipickerService.getTestAssignedDatasource(
        this.multipickerService.getActiveTestQueuedStatus(
          this.deviceWithMonitors,
          item.deviceData.id
        ),
        item.deviceData.name
      );
    });
    return this.sumOfTestAssignedForAllDevices(allTestAssignedValues);
  }

  //eslint-disable-next-line
  sumOfTestAssignedForAllDevices(allTestAssignedValues) {
    const testAssignedValues = {
      voip: [],
      service: [],
      network: [],
      truespeed: [],
      multistep: []
    };
    for (const key in testAssignedValues) {
      const value = [];
      allTestAssignedValues.forEach(item => {
        const matchingEl = item.find(el => el.type === key && el.overalPercentage >= 0);
        if (matchingEl) {
          value.push(matchingEl);
        }
        testAssignedValues[key] = value;
      });
    }
    let testAssigned = [
      this.sumOfArrayValues(testAssignedValues['voip']),
      this.sumOfArrayValues(testAssignedValues['network']),
      this.sumOfArrayValues(testAssignedValues['service']),
      this.sumOfArrayValues(testAssignedValues['truespeed']),
      this.sumOfArrayValues(testAssignedValues['multistep'])
    ];
    testAssigned = testAssigned.filter(item => item);
    if (testAssigned.length === 0) {
      testAssigned = [
        {
          used: null,
          max: null,
          className: null,
          maxCount: null,
          overalUsed: null,
          overalPercentage: null,
          deviceName: null,
          hasOveralPercentage: 'none',
          showProgressBar: 'block',
          width: '40%',
          hideView: true,
          type: null
        }
      ];
    }
    return testAssigned;
  }
  sendSelectedItem(event: { type: string }): void {
    if (this.singleSelection) {
      if (this.deviceComp && this.deviceComp?.deviceTable?.table?.deselectRow)
        this.deviceComp.deviceTable.table.deselectRow();
      const oldRowSelection = Object.assign([], this.siteTable.table.getSelectedData());
      if (oldRowSelection.length > 1) {
        const x = oldRowSelection[0];
        this.siteTable.table.deselectRow(x.id);
      }
    }
    const actualTest =
      this.monitorsService.monitorCountResponse.success.monitorMaxLimit -
      this.monitorsService.monitorCountResponse.success.activeMonitorsCount;
    if (
      this.siteTable?.selection?.length + this.multipickerService.selectedDevices.length >
      this.multipickerService.TEST_LIMIT_COUNT
    ) {
      this.deselectRows(event);
      this.multipickerService.showBulkTestLimitDialog();
    } else if (
      this.siteTable?.selection?.length + this.multipickerService.selectedDevices.length >
      actualTest
    ) {
      const testInfo = {
        maxLimit: this.monitorsService.monitorCountResponse.success.monitorMaxLimit,
        activeCount: this.monitorsService.monitorCountResponse.success.activeMonitorsCount
      };
      const warningMsg = this.monitorsService.getWarningMessage(testInfo);
      this.deselectRows(event);
      this.multipickerService.showTestLimitDialog(warningMsg);
    } else {
      this.multipickerService.selectedSites = this.siteTable.selection;
    }
  }
  //eslint-disable-next-line
  sumOfArrayValues(data: any): any {
    if (data.length > 0) {
      const used = data.reduce((sum, item) => sum + Number(item.used), 0);
      const max = data.reduce((sum, item) => sum + Number(item.max), 0);
      const overalUsed = data.reduce((sum, item) => sum + Number(item.overalUsed), 0);
      const maxCount = data.reduce((sum, item) => sum + Number(item.maxCount), 0);
      const overalPercentage = Math.round((100 * overalUsed) / maxCount);
      return {
        className: data[0].className,
        deviceName: data[0].deviceName,
        hasOveralPercentage: data[0].hasOveralPercentage,
        hideView: true,
        max: max,
        maxCount: maxCount,
        overalPercentage: overalPercentage,
        overalUsed: overalUsed,
        showProgressBar: data[0].showProgressBar,
        type: data[0].type,
        used: used,
        width: '40%'
      };
    }
  }
  // eslint-disable-next-line
  deselectRows(event: any): void {
    if (event.type === 'multiple') {
      this.siteTable.table.deselectRow();
    } else {
      const oldRowSelection = Object.assign([], this.siteTable.table.getSelectedData());
      const x = oldRowSelection.pop();
      this.siteTable.table.deselectRow(x.id);
    }
  }
}
